import _ from 'lodash'
import { createSelector } from 'reselect'
import { populateLogs } from './Logs'

export const getAllReports = (state) => state.data['body-map-reports']

export const getBodyMapLogs = createSelector([populateLogs], (logs) => {
  return _.filter(
    logs,
    (log) => !!log.bodyMapReport || !_.isEmpty(log.bodyMapReports)
  )
})

export const getAllBodyMapReports = createSelector(
  [getAllReports, getBodyMapLogs],
  (reports, logs) => {
    if (!reports || !logs) return null

    const logsByReportId = {}
    logs.forEach((log) => {
      const reportIds = _.uniq(
        _.compact([log.bodyMapReport, ...(log.bodyMapReports || [])])
      )
      reportIds.forEach((reportId) => {
        logsByReportId[reportId] = logsByReportId[reportId] || []
        logsByReportId[reportId].push(log)
      })
    })

    const reportsWithLogs = reports.map((report) => ({
      ...report,
      logs: logsByReportId[report.id] || null
    }))

    return [...reportsWithLogs].sort(
      (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
    )
  }
)

const getResidentId = (state, { resident }) => resident
export const getResidentBodyMapReports = createSelector(
  [getAllBodyMapReports, getResidentId],
  (reports, resident) => {
    if (!reports || !resident) return null
    return _.filter(reports, { resident })
  }
)

const getId = (state, { id }) => id
// find body map report by ID
export const getResidentBodyMapReport = createSelector(
  [getAllBodyMapReports, getId],
  (reports, id) => {
    if (!reports || !id) return null
    return _.find(reports, { id })
  }
)
